/**
 * This file is generated from scripts/genIconComponents.ts. Any
 * changes should be made in that file.
 */
import React, { CSSProperties, forwardRef, Ref } from "react";
import { GeneratedIconProps } from "../../components/icon/GeneratedIconProps";
import { Icon } from "../../components/icon/Icon";
import ExclamationOnDotIcon10 from "./ExclamationOnDotIcon10";
import ExclamationOnDotIcon16 from "./ExclamationOnDotIcon16";
import ExclamationOnDotIcon20 from "./ExclamationOnDotIcon20";
import ExclamationOnDotIcon24 from "./ExclamationOnDotIcon24";

const getSizeMap = (viewBox?: string, width?: string | number, height?: string | number) => {
    return {
        10: viewBox ? (
            <ExclamationOnDotIcon10 viewBox={viewBox} width={width ? width : 10} height={height ? height : 10} />
        ) : (
            <ExclamationOnDotIcon10 width={width ? width : 10} height={height ? height : 10} />
        ),
        16: viewBox ? (
            <ExclamationOnDotIcon16 viewBox={viewBox} width={width ? width : 16} height={height ? height : 16} />
        ) : (
            <ExclamationOnDotIcon16 width={width ? width : 16} height={height ? height : 16} />
        ),
        20: viewBox ? (
            <ExclamationOnDotIcon20 viewBox={viewBox} width={width ? width : 20} height={height ? height : 20} />
        ) : (
            <ExclamationOnDotIcon20 width={width ? width : 20} height={height ? height : 20} />
        ),
        24: viewBox ? (
            <ExclamationOnDotIcon24 viewBox={viewBox} width={width ? width : 24} height={height ? height : 24} />
        ) : (
            <ExclamationOnDotIcon24 width={width ? width : 24} height={height ? height : 24} />
        ),
    };
};

export interface ExclamationOnDotIconProps extends GeneratedIconProps {
    /**
     * The size to render the icon at.
     */
    size: 10 | 16 | 20 | 24;

    /**
     * The fill color for the exclamation point.
     */
    innerShapeColor?: string;
}

export const ExclamationOnDotIcon = forwardRef(
    (
        {
            // This is the default icon color.
            color = "var(--sds--symbol--background-color--yellow--default, var(--smar--com--color--yellow--200,#dea41b))",
            size,
            viewBox,
            width,
            height,
            style,
            innerShapeColor,
            ...rest
        }: ExclamationOnDotIconProps,
        ref: Ref<HTMLElement>
    ) => {
        return (
            <Icon
                color={color}
                ref={ref}
                size={size}
                width={width}
                height={height}
                {...rest}
                style={
                    {
                        ...style,
                        "--sds--ursa-icons--inner-shape-color": innerShapeColor,
                    } as CSSProperties
                }
            >
                {getSizeMap(viewBox, width, height)[size]}
            </Icon>
        );
    }
);
ExclamationOnDotIcon.displayName = "ExclamationOnDotIcon";
